import { ScreenerService, SymbolsService } from 'core/services';
import { DI } from 'core/di-container';
import { useState } from 'react';
import { Spinner } from 'react-bootstrap';

const symbolsService: SymbolsService = DI.get(SymbolsService);
const screenerService: ScreenerService = DI.get(ScreenerService);

export function Bootstrap({ children }: { children: JSX.Element }) {
  const [loading, setLoading] = useState(true);

  if (loading) {
    Promise.all([symbolsService.cacheSymbols(), screenerService.cacheScreenerConfig()]).then(() => {
      setLoading(false);
    });
    return (
      <Spinner animation="border" variant="dark" style={{ position: 'absolute', left: 'calc(50% - 16px)', top: 'calc(50% - 16px)' }} />
    );
  }

  return children;
}
